import styled from 'styled-components'
import Image from 'common/image'
import WinsIcon from 'assets/wins_icon.png'
import { useTranslation } from 'react-i18next'
// import { adobeInteractionEvent } from 'utils/adobewa'

const BoxContainer = styled.div`
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    width: 1164px;
    padding: 48px;
    justify-content: flex-start;
    align-items: flex-start;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 1px 1px 15px 0 rgba(0, 0, 0, 0.1);
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 56px;
`

const TitleText = styled.div`
    color: #121b21;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
`

const TitleUnderLine = styled.div`
    width: 80px;
    height: 5px;
    background: #d9c277;
`

const SuggestionItemRow = styled.div`
    width: 100%;
    margin-top: 32px;
    display: flex;
    flex-direction: row;
    gap: 71px;
`

const SuggestionItem = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 12px;
`

// const SuggestionItemIcon = styled.div`
//     display: flex;
//     width: 100px;
//     height: 100px;
//     padding: 28px 29.375px 27px 29.375px;
//     justify-content: center;
//     align-items: center;
//     flex-shrink: 0;
//     aspect-ratio: 1/1;
//     border-radius: 70px;
//     border: 1px solid #c5924d;
// `

const SuggestionTextContainer = styled.div`
    display: flex;
    flex-direction: column;
`

const SuggestionText = styled.div`
    width: 100%;
    color: #4e3821;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 23px; /* 143.75% */
`

const SuggestionRatioContainer = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: row;
`

const SuggestionRatio = styled.div`
    margin-left: 6px;
    color: #4e3821;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px; /* 125% */
`

const SeparateLine = styled.div`
    width: 1px;
    height: 94px;
    background-color: #f0f0f0;
`

const RightSuggestionItemContainer = styled.div`
    height: 100px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
`

const RightSuggestionText = styled.div`
    color: #4e3821;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 23px; /* 143.75% */
`

// const JoinUsButton = styled.div`
//     margin-top: 48px;
//     width: 296px;
//     display: flex;
//     min-height: 55px;
//     padding: 8px 48px;
//     justify-content: center;
//     align-items: center;
//     border-radius: 200px;
//     background: #c5924d;
//     align-self: center;
//     cursor: pointer;
// `

// const JoinUsText = styled.div`
//     color: #fff;
//     font-size: 16px;
//     font-weight: 700;
//     line-height: 20px; /* 125% */
// `

export default function WayToSpendWins() {
    const { t } = useTranslation('', {
        keyPrefix: 'spendwins.waytospendwins',
    })

    // const tutorialButtonOnClick = () => {
    //     adobeInteractionEvent({
    //         lang: lang,
    //         eventID: `prioritysite_click_SpendWins_Ways_Tutorial`,
    //     })
    // }

    return (
        <BoxContainer>
            <TitleContainer>
                <TitleText>{t(`SPENDWINS`)}</TitleText>
                <TitleUnderLine />
            </TitleContainer>
            <SuggestionItemRow>
                <SuggestionItem>
                    <Image
                        src={t(`icon1`)}
                        width={100}
                        height={100}
                        alt="account icon"
                    />
                    <SuggestionTextContainer>
                        <SuggestionText>{t(`text1`)}</SuggestionText>
                        <SuggestionRatioContainer>
                            <Image
                                src={WinsIcon}
                                width={40}
                                height={40}
                                alt="wins icon"
                                style={{
                                    marginTop: '-5px',
                                }}
                            />
                            <SuggestionRatio>{t(`HKD`)}</SuggestionRatio>
                        </SuggestionRatioContainer>
                    </SuggestionTextContainer>
                </SuggestionItem>
                <SeparateLine />
                <SuggestionItem>
                    <RightSuggestionItemContainer>
                        <Image
                            src={t(`icon2`)}
                            width={100}
                            height={100}
                            alt="Calendar icon"
                        />
                        <RightSuggestionText>{t(`text2`)}</RightSuggestionText>
                    </RightSuggestionItemContainer>
                </SuggestionItem>
            </SuggestionItemRow>
            <SuggestionItemRow>
                <SuggestionItem>
                    <Image
                        src={t(`icon3`)}
                        width={100}
                        height={100}
                        alt="account icon"
                    />
                    <RightSuggestionItemContainer>
                        <RightSuggestionText>{t(`text3`)}</RightSuggestionText>
                    </RightSuggestionItemContainer>
                </SuggestionItem>
                <SeparateLine />
                <SuggestionItem>
                    <RightSuggestionItemContainer>
                        <Image
                            src={t(`icon4`)}
                            width={100}
                            height={100}
                            alt="Calendar icon"
                        />
                        <RightSuggestionText>{t(`text4`)}</RightSuggestionText>
                    </RightSuggestionItemContainer>
                </SuggestionItem>
            </SuggestionItemRow>
            {/* <JoinUsButton onClick={() => tutorialButtonOnClick()}>
                <JoinUsText>
                    {t(`spendwins.waytospendwins.Tutorialofjoinning`)}
                </JoinUsText>
            </JoinUsButton> */}
        </BoxContainer>
    )
}
